import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';

class LectureDropdown extends Component {
    componentDidMount(){
        if(this.props.sc.length === 0){
            this.props.loadCourse(this.props.courseId);
        }
    }
    
    renderPrevious = () => {
        let {sc} = this.props;
        let index = -1;
        if(sc){
            sc.map((l, i) => {
                if(l.id === this.props.currentId){
                    return index = i;
                }else{
                    return null;
                }
            })
            
            let newPart = null;
            if(index > 0){
                newPart = sc[index - 1];
            }
            

            return (
                <Link to={`/edit-lecture/${newPart ? newPart.id : ''}`} className={`btn btn-default ${!newPart ? 'disabled' : ''}`}><i className="zmdi zmdi-arrow-left" /> &nbsp; Previous</Link>  
            )
        }else{
            return null;
        }
        
    }
    
     renderNext = () => {
        let {sc} = this.props;
        if(sc){
            let index = -1;
            sc.map((l, i) => {
                if(l.id === this.props.currentId){
                    return index = i;
                }else{
                    return null;
                }
            })
            
            let newPart = null;
            if(index < sc.length - 1){
                newPart = sc[index + 1];
            }

            return (
                <Link to={`/edit-lecture/${newPart ? newPart.id : ''}`} className={`btn btn-default ${!newPart ? 'disabled' : ''}`}>Next &nbsp; <i className="zmdi zmdi-arrow-right" /></Link>  
            )
        }else{
            return null;
        }
        
        
    }
    
    renderDropdown = () => {
        let part = this.props.sc.filter(p => p.id === this.props.currentId);
        
        if(part.length > 0){
            part = part[0];
            
            if(this.props.sc){
                return (
                    <span className="dropdown user-nav-right-side">
                    <button className="dropdown-toggle btn btn-default" style={{height: 'initial', width: '360px', overflow: 'hidden'}} data-toggle="dropdown" aria-expanded="true">
                        {part.title ? part.title : 'Untitled Lecture'}
                    </button>
                    
                    <div className="dropdown-menu lecture-dropdown">
                        <Scrollbars style={{ height: "60vh", width: "360px", overflow: "hidden"}}>
    
                            {this.props.sc.map((p, i) => {
                                return (
                                    <Link to={`/edit-lecture/${p.id}`} className={`${p.id === this.props.currentId ? 'active' : ''}`}>{i + 1}. {p.title ? p.title : 'Untitled Lecture'}</Link>    
                                )
                            })
                            }
                            
                        </Scrollbars>
                    </div>
                    </span>
                    
                )
            }else{
                return null;
            }
        }
    }

    render(){

        return (
            <div>
                {this.renderPrevious()}
                &nbsp;
                {this.renderDropdown()}
                &nbsp;
                {this.renderNext()}
            </div>
        )
        
    }
}

export default LectureDropdown;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/LectureDropdown.js